/**
 * Conjunto de Utilidades
 * <p>Grupo de Funciones Utiles para nuestros proyectos</p>
 * @module Utils
 */
import * as Utils from './Utils.js'
import template from './Template.js'
import * as Colors from './Colors.js'


export default {
	Colors,
    Utils,
	template
}
